<template>
	<div class="" v-loading="loading">
		<div >
			<el-tree
				ref="treeCheckDepartmentSingle"
				:data="treeData"
				:expand-on-click-node="false"
				:props="{ label: 'name' }"
				:default-expand-all="true"
				:highlight-current="true"
				node-key="id"
				check-strictly
				:indent="0"
				check-on-click-node
				class="tree-line"
				@current-change="changeCurrentDeptSingle"
			></el-tree>
		</div>
	</div>
</template>

<script>
export default {
	name: 'check-department-single',
	props: {
		data: {
			type: Array,
			default: () => {
				return [];
			}
		},
		config: {
			type: Object,
			default: () => {
				return { props: { label: 'name' }, key: 'id' };
			}
		}
	},
	data() {
		return {
			cfg: {},
			loading: false,
			treeData: [],
			errorMsg: ''
		};
	},
	created: function() {},
	mounted() {
		this.cfg = this.config;
		this.treeData = this.data;
	},
	methods: {
		changeCurrentDeptSingle(d) {
			this.$emit('check', d);
		}
	},
	watch: {
		data: function(d) {
			this.treeData = d;
		}
	}
};
</script>

<style>
.tree-line .el-tree-node {
	position: relative;
	padding-left: 10px;
}
.tree-line .el-tree-node__children {
	padding-left: 10px;
}
.tree-line .el-tree-node::before {
	content: '';
	height: 100%;
	width: 1px;
	position: absolute;
	left: -3px;
	top: -26px;
	border-width: 1px;
	border-left: 1px dashed #ddd;
}
.tree-line .el-tree-node:last-child::before {
	height: 38px;
}
.tree-line .el-tree-node::after {
	content: '';
	width: 24px;
	height: 20px;
	position: absolute;
	left: -3px;
	top: 12px;
	border-width: 1px;
	border-top: 1px dashed #ddd;
}
.tree-line > .el-tree-node::after {
	border-top: none;
}
.tree-line > .el-tree-node::before {
	border-left: none;
}
.tree-line .el-tree-node__expand-icon {
	font-size: 10px;
}
.tree-line .el-tree-node__expand-icon.is-leaf {
	color: transparent;
}
.tree-menu.el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
	background-color: #515a6e;
	color: #fff;
}
</style>
